namespace('compass.util');

(function(undefined) {

// Builds a trie of formatters, where each node
// is a single character in the format string, and
// the leaf is the formatter associated with that
// format string.
function _buildFormatTree(formats) {
	function makeNode() {
		return { a : { }, f : undefined };
	}

  var root = makeNode();
  root.root = '__ROOT__';
  _.each(formats, function(format) {
    var curr = root;
    var next;
    _.each(format.formatString.split(''), function(c) {
      next = curr.a[c];
      if(next) {
        curr = next;
      } else {
        next = curr.a[c] = makeNode();
        curr = next;
      }
    });
    curr.f = format.formatter;
  });
  return root;
}

function _buildFormatter(formats) {
  var root = _buildFormatTree(formats);

	return function dateFormatter(formatString) {
		var formatters = [ ];

		var chars = formatString.split('');
		var count = chars.length;

		function freeText(str) {
			return function(d) { return str; };
		}

		var c;
		var curr = root;
		var next;
		var buffer = '';
		for(var i = 0; i < count; i++) {
			c = chars[i];
			next = curr.a[c];
			if(next) {
				if(buffer.length > 0) {
					formatters.push(freeText(buffer));
					buffer = '';
				}
				curr = next;
			} else {
				if(curr.f) {
					formatters.push(curr.f);
				}
				buffer += c;
				curr = root;
			}
		}

		if(curr.f) {
			formatters.push(curr.f);
		} else if(buffer.length > 0) {
			formatters.push(freeText(buffer));
		}

		return function(d) {
			if(d) { return _.foldl(formatters, function(str, f) { return str + f(d); }, ''); }
		};
	};
}

var dateNames = {
	days : [
		{ name : 'Sunday', shortName : 'Sun' },
		{ name : 'Monday', shortName : 'Mon' },
		{ name : 'Tuesday', shortName : 'Tue' },
		{ name : 'Wednesday', shortName : 'Wed' },
		{ name : 'Thursday', shortName : 'Thu' },
		{ name : 'Friday', shortName : 'Fri' },
		{ name : 'Saturday', shortName : 'Sat' }
	],
	months : [
		{ name : 'January', shortName : 'Jan' },
		{ name : 'February', shortName : 'Feb' },
		{ name : 'March', shortName : 'Mar' },
		{ name : 'April', shortName : 'Apr' },
		{ name : 'May', shortName : 'May' },
		{ name : 'June', shortName : 'Jun' },
		{ name : 'July', shortName : 'Jul' },
		{ name : 'August', shortName : 'Aug' },
		{ name : 'September', shortName : 'Sep' },
		{ name : 'October', shortName : 'Oct' },
		{ name : 'November', shortName : 'Nov' },
		{ name : 'December', shortName : 'Dec' }
	]
};

/*
	d: Day of the month as digits; no leading zero for single-digit days.
	dd: Day of the month as digits; leading zero for single-digit days.
	ddd: Day of the week as a three-letter abbreviation.
	dddd: Day of the week as its full name.
	m: Month as digits; no leading zero for single-digit months.
	mm: Month as digits; leading zero for single-digit months.
	mmm: Month as a three-letter abbreviation.
	mmmm: Month as its full name.
	yy: Year as last two digits; leading zero for years less than 10.
	yyyy: Year represented by four digits.
	gg: Period/era string. Ignored. Reserved.

	short: equivalent to m/d/y
	medium: equivalent to mmm d, yyyy
	long: equivalent to mmmm d, yyyy
	full: equivalent to dddd, mmmm d, yyyy
*/
var dateFormats = [
  { formatString : 'd', formatter : function(d) { return '' + d.getDate(); }},
  { formatString : 'dd', formatter : function(d) { var day = d.getDate(); return day < 10 ? '0' + day : '' + day; }},
  { formatString : 'ddd', formatter : function(d) { return dateNames.days[d.getDay()].shortName; }},
  { formatString : 'dddd', formatter : function(d) { return dateNames.days[d.getDay()].name; }},
  { formatString : 'm', formatter : function(d) { return '' + (d.getMonth() + 1); }},
  { formatString : 'mm', formatter : function(d) { var month = d.getMonth() + 1; return month < 10 ? '0' + month : '' + month; }},
  { formatString : 'mmm', formatter : function(d) { return dateNames.months[d.getMonth()].shortName; }},
  { formatString : 'mmmm', formatter : function(d) { return dateNames.months[d.getMonth()].name; }},
  { formatString : 'yy', formatter : function(d) { var year = '' + d.getFullYear(); return year.substring(2); }},
  { formatString : 'yyyy', formatter : function(d) { return '' + d.getFullYear(); }},
  { formatString : 'gg', formatter : function(d) { return ''; }},
  { formatString : 'short', formatter : function(d) { return compass.util.dateFormatter('m/d/yy')(d); }},
  { formatString : 'medium', formatter : function(d) { return compass.util.dateFormatter('mmm d, yyyy')(d); }},
  { formatString : 'long', formatter : function(d) { return compass.util.dateFormatter('mmmm d, yyyy')(d); }},
  { formatString : 'full', formatter : function(d) { return compass.util.dateFormatter('dddd, mmmm d, yyyy')(d); }}
];

compass.util.dateFormatter = _buildFormatter(dateFormats);

var symbolDefaults = {
	AED : { symbol : '' },
	AUD : { symbol : '$' },
	BRL : { symbol : 'R$' },
	CAD : { symbol : '$' },
	CNY : { symbol : '\u00A5' },
	EUR : { symbol : '\u20AC' },
	GBP : { symbol : '\u00A3' },
	HKD : { symbol : 'HK$' },
	INR : { symbol : '\u20B9', showDecimals : 0 },
	JPY : { symbol : '\u00A5', showDecimals : 0 },
	KRW : { symbol : '\u20A9', showDecimals : 0 },
	NZD : { symbol : '$' },
	RMB : { symbol : '\u00A5' },
	RUB : { symbol : '\u0440\u0443\u0431.' },
	SGD : { symbol : 'S$' },
	THB : { symbol : '\u0E3F', showDecimals : 0 },
	USD : { symbol : '$' },
	MYR : { symbol : 'RM' },
	DKK : { symbol : 'kr' },
	ZAR : { symbol : 'R' },
	TRY : { symbol : '\u20BA' },
	COP : { symbol : '$' }
};

function currencyFormatter(currencyCode, options) {
	var opts = jQuery.extend({ }, {
		symbol : '',
		separator : ',',
		decimal : '.',
		showDecimals : 2
	}, symbolDefaults[currencyCode] || { symbol : currencyCode }, options);
	var pattern = /(\d)(?=(\d{3})+$)/g;

	return function(value) {
		var str = String(Number(value).toFixed(2));
		var split = str.indexOf('.');
		var whole, partial;
		if(split > 0) {
			whole = str.substring(0, split);
			partial = str.substring(split + 1, split + 3);
			while(partial.length < opts.showDecimals) { partial += '0'; }
		} else {
			whole = str;
			partial = '';
			while(partial.length < opts.showDecimals) { partial += '0'; }
		}

		var number = whole.replace(pattern, '$1' + opts.separator);
		if(opts.showDecimals > 0) {
			number += opts.decimal + partial;
		}

		// handles when the currency symbol needs to be handled differently from a typical single character symbol ex: CAD$ is a special case in arctic
		if(opts.returnAsObject) {
			return { symbol: opts.symbol, value: number };
		}
		return opts.symbol + number;
	};
}

function phoneFormatter(options) {
	return function (number) {
		// strip number to avoid misformatting
		var cleaned = ('' + number).replace(/\D/g, '');
		var formatted = "";
		if (cleaned.length === 11) {
			formatted += cleaned[0] + " ";
			cleaned = cleaned.slice(1);
		}

		if (cleaned.length === 10) {
			formatted += "(" + cleaned.substr(0,3) + ") ";
			cleaned = cleaned.slice(3);
		}

		if(cleaned.length === 7) {
			formatted += cleaned.substr(0,3) + "-" + cleaned.substr(3);
		} else {
			formatted = cleaned;
		}

		return formatted;
	};
}

function getCurrencySymbolFromCode(currencyCode, defaultSymbol) {
	defaultSymbol = (defaultSymbol === undefined) ? '$' : defaultSymbol;
	var symbolObject = symbolDefaults[currencyCode];
	return (symbolObject !== undefined) ? symbolObject.symbol : defaultSymbol;
}

compass.util.currencyFormatter = currencyFormatter;
compass.util.getCurrencySymbolFromCode = getCurrencySymbolFromCode;
compass.util.phoneFormatter = phoneFormatter;

})();

